import React, { useEffect, useState } from "react";
import Sidebar from "../Sidebar/Sidebar";
import "./Member.css";
import Navbar from "./Navbar";
import Header from "./header";
import MyTable from "./Table";
import moment from "moment";
import ApiConfig from "../../common/config/ApiConfig";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLanguage } from "../../common/i18n/LanguageContext";

const LIMIT = 10;

function Loginslog() {
  const { t } = useLanguage();
  const user = localStorage.getItem("user");
  const pos = localStorage.getItem("position");
  const subuser = localStorage.getItem("subuser");
  const [login, setLogin] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  const MemberGet = async (user, currentPage) => {
    const params = new URLSearchParams({
      user,
      page: currentPage,
      limit: LIMIT,
    });
    const res = await ApiConfig.get(`/getlogin_log?${params.toString()}`);
    if (!res.resCode || res.resCode !== 200) {
      toast.error(res?.message || t("common_load_error"), {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }
    const result = await res.data;
    setLogin(
      Array.isArray(result?.data)
        ? result.data
        : Array.isArray(result)
          ? result
          : [],
    );
    if (result?.total != null) setTotal(result.total);
  };

  const activeUser = pos === "sub_account" ? subuser : user;

  useEffect(() => {
    MemberGet(activeUser, page);
    // eslint-disable-next-line
  }, [page, activeUser]);

  const totalPages = total > 0 ? Math.ceil(total / LIMIT) : 0;

  const memberColumns = [
    {
      Header: t("login_username_label"),
      accessor: "username",
      align: "center",
      Cell: ({ value }) => <span className="font-bold">{value}</span>,
      widthClass: "w-1/6",
    },
    {
      Header: t("membertable_tx_col_date"),
      accessor: "login_date",
      align: "right",
      Cell: ({ value }) => (
        <span className="text-[12px] font-bold">
          {moment(value).format(
            `[${t("loginlog_date_prefix")}] DD MMMM YYYY [${t(
              "loginlog_time_prefix",
            )}] HH:MM`,
          )}
        </span>
      ),
      widthClass: "w-1/6",
    },
    {
      Header: "IP Address",
      accessor: "ip",
      align: "right",
      Cell: ({ value }) => <span className="text-[12px]">{value}</span>,
      widthClass: "w-1/6",
    },
    {
      Header: "Device",
      accessor: "device",
      align: "right",
      Cell: ({ value }) => (
        <span className="text-[12px] font-bold">{value}</span>
      ),
      widthClass: "w-1/6",
    },
  ];

  return (
    <div className="h-screen flex flex-col overflow-hidden">
      <div className="shrink-0">
        <Navbar />
      </div>
      <div className="flex flex-1 overflow-hidden items-start">
        <div className="shrink-0 overflow-y-auto h-full">
          <Sidebar pos={pos} />
        </div>
        <div className="flex flex-col flex-1 max-h-full overflow-hidden">
          <div className="shrink-0">
            <Header title={t("menu_login_history")} />
          </div>
          <div className="flex-1 overflow-y-auto">
            <div className="p-1">
              <MyTable
                columns={memberColumns}
                data={login}
                fontSizeClass="text-[12px]"
              />

              {(totalPages > 1 || login.length > 0) && (
                <div className="flex items-center justify-between mt-3 px-2">
                  <span className="text-[12px] font-semibold text-brand-blue-700 bg-brand-blue-50 px-3 py-1 rounded-full border border-brand-blue-200">
                    {t("commission_page_label")} {page}
                    {totalPages > 0 ? ` / ${totalPages}` : ""}
                    {total > 0 && ` · ${total} ${t("common_items_unit")}`}
                  </span>
                  <div className="flex space-x-1">
                    <button
                      onClick={() => setPage(1)}
                      disabled={page === 1}
                      className="px-2 py-1 text-[12px] font-bold rounded bg-gray-200 text-gray-700 hover:bg-gray-300 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
                    >
                      «
                    </button>
                    <button
                      onClick={() => setPage((p) => Math.max(1, p - 1))}
                      disabled={page === 1}
                      className="px-3 py-1 text-[12px] font-medium rounded bg-brand-blue-100 text-brand-blue-700 hover:bg-brand-blue-200 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
                    >
                      ‹ {t("common_page_previous")}
                    </button>
                    <span className="px-3 py-1 text-[12px] font-bold rounded bg-brand-blue-600 text-white select-none">
                      {page}
                    </span>
                    <button
                      onClick={() => setPage((p) => p + 1)}
                      disabled={totalPages > 0 && page >= totalPages}
                      className="px-3 py-1 text-[12px] font-medium rounded bg-brand-blue-100 text-brand-blue-700 hover:bg-brand-blue-200 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
                    >
                      {t("common_next")} ›
                    </button>
                    {totalPages > 0 && (
                      <button
                        onClick={() => setPage(totalPages)}
                        disabled={page >= totalPages}
                        className="px-2 py-1 text-[12px] font-bold rounded bg-gray-200 text-gray-700 hover:bg-gray-300 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
                      >
                        »
                      </button>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Loginslog;
